const DefaultTableAvatarImage = ({src, alt}: {src?: string | null; alt: string}) => {
  return (
    <img
      src={src || '/images/logo/logo.png'}
      alt={alt}
      className={`${src ? '' : 'object-contain'} h-10 w-10 rounded-sm`}
    />
  );
};

export default DefaultTableAvatarImage;
